export const imageProvider = (baseApiUrl) => ({
  providers: {
    imageProvider: {
      name: 'imageProvider',
      provider: `${__dirname, '..'}/providers/imageProvider`,
      options: {
        modifiers: {
          format: 'webp',
          // quality: 100
        },
        baseURL: `${baseApiUrl}storage/image/`,
      },
    },
  },
  provider: 'imageProvider',
});
